import { useEffect, useRef, useState } from 'react';
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateCalendar} from '@mui/x-date-pickers';
import { sxCalendar } from './sxProps';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/pt-br';

dayjs.locale('pt-br');

interface CalendarProps {
  handleDate: (arg: Date) => void,
  handleMonth: (arg1: Date) => void,
  daysList: string[],
  selectedDate: Date | null,
  isLoading?: boolean
}

function Calendar(props: CalendarProps){
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
    const [monthNum, setMonthNum] = useState<number>(0);
    const calendarRef = useRef<HTMLDivElement>(null);
    const shouldRestoreFocus = useRef<boolean>(false);
    const lastFocusedElement = useRef<Element | null>(null);

    useEffect(() => {
      if(props.selectedDate !== null){
        setSelectedDate(dayjs(props.selectedDate))
        setMonthNum(dayjs(props.selectedDate).month())
      }
      else {
        setMonthNum(dayjs().month());
      }
    }, [props.selectedDate])

    useEffect(() => {
      if (props.isLoading === false && shouldRestoreFocus.current && calendarRef.current) {
          setTimeout(() => {
              if (lastFocusedElement.current && document.contains(lastFocusedElement.current)) {
                  (lastFocusedElement.current as HTMLElement).focus();
              } else {
                  const focusableElements = calendarRef.current?.querySelectorAll(
                      'button[tabindex="0"], [role="button"][tabindex="0"]'
                  );
                  if (focusableElements && focusableElements.length > 0) {
                      (focusableElements[0] as HTMLElement).focus();
                  }
              }
              shouldRestoreFocus.current = false;
              lastFocusedElement.current = null;
          }, 100);
      }
  }, [props.isLoading]);

    useEffect(() => {
   
    }, [monthNum]);



    const handleDateChange = (date: Dayjs | null) => {
      if(date !== null){
        setSelectedDate(date);
        props.handleDate(date.toDate())
      }
    }

    const getDayName = (dayNumber: string) => {
        switch (dayNumber) {
          case 'Do':
            return 'D';
          case '2ª':
            return 'S';
          case '3ª':
            return 'T';
          case '4ª':
            return 'Q';
          case '5ª':
            return 'Q';
          case '6ª':
            return 'S';
          case 'Sá':
            return 'S';
        }
    }

    function disableDays(date: Dayjs) {
        let findDate = props.daysList.some(day => dayjs(day, 'DD/MM/YYYY').isSame(date));
        return !findDate;
    }
      
    const handleMonthChange = (date: Dayjs) => {
      setMonthNum(date.month());
      props.handleMonth(date.toDate());

      lastFocusedElement.current = document.activeElement;
      shouldRestoreFocus.current = true;
    }
    
    return (
        <div className="calendar" ref={calendarRef}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DateCalendar 
                    sx={sxCalendar} 
                    value={selectedDate}
                    onChange={handleDateChange}
                    onMonthChange={handleMonthChange}
                    shouldDisableDate={disableDays}
                    dayOfWeekFormatter={(day: string) => `${getDayName(day)}`}
                    slotProps={{
                      day: {
                          sx: {
                              '&:focus': {
                                  outline: '2px solid #1976d2',
                                  outlineOffset: '2px',
                                  borderRadius: '50%',
                              },
                              '&.Mui-selected:focus': {
                                  outline: '2px solid #004ba0',
                              },
                          },
                      },
                  }}
                />
            </LocalizationProvider>
        </div>
    );
}

export default Calendar;